import { NgModule } from '@angular/core';
import { Route, RouterModule } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [
    {
        path: 'public',
        children: [
            {
                path: 'model-simulation',
                loadChildren: () =>
                    import(
                        'app/modules/mst/public/model-simulation-public.module'
                    ).then((m) => m.AnimalPopulationPublicModule),
            },
        ],
    },

    // Redirect empty path to '/mpb'
    { path: '', pathMatch: 'full', redirectTo: 'home' },

    // Redirect signed-in user to '/mpb'
    {
        path: 'signed-in-redirect',
        pathMatch: 'full',
        redirectTo: 'powerbi/reports',
    },

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'confirmation-required',
                loadChildren: () =>
                    import(
                        'app/modules/auth/confirmation-required/confirmation-required.routes'
                    ),
            },
            {
                path: 'forgot-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/forgot-password/forgot-password.routes'
                    ),
            },
            {
                path: 'reset-password',
                loadChildren: () =>
                    import(
                        'app/modules/auth/reset-password/reset-password.routes'
                    ),
            },
            {
                path: 'sign-in',
                loadChildren: () =>
                    import('app/modules/auth/sign-in/sign-in.routes'),
            },
        ],
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty',
        },
        children: [
            {
                path: 'sign-out',
                loadChildren: () =>
                    import('app/modules/auth/sign-out/sign-out.routes'),
            },
            {
                path: 'unlock-session',
                loadChildren: () =>
                    import(
                        'app/modules/auth/unlock-session/unlock-session.routes'
                    ),
            },
        ],
    },

    // Dashboard routes
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        resolve: {
            initialData: initialDataResolver,
        },
        children: [
            {
                path: 'home',
                loadChildren: () =>
                    import('app/modules/home/home.module').then(
                        (m) => m.homeModule
                    ),
            },
            {
                path: 'mip',
                loadChildren: () =>
                    import('app/modules/mip/mip.module').then(
                        (m) => m.MipModule
                    ),
            },
            {
                path: 'mst',
                loadChildren: () =>
                    import('app/modules/mst/mst.module').then(
                        (m) => m.MstModule
                    ),
            },
            {
                path: 'settings',
                loadChildren: () =>
                    import('app/modules/settings/settings.routes'),
            },
            {
                path: 'powerbi',
                loadChildren: () =>
                    import(
                        'app/modules/mip/powerbi-report/powerbi-report.module'
                    ).then((m) => m.ProductLevelReportingModule),
            },
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard',
            },
        ],
    },
    // Wildcard route for undefined paths
    {
        path: '**',
        loadComponent: () =>
            import('app/modules/error-404/error-404.component').then(
                (m) => m.Error404Component
            ),
        pathMatch: 'full',
    },
];

@NgModule({
    imports: [RouterModule.forRoot(appRoutes)],
    exports: [RouterModule],
})
export class AppRoutingModule {}
